module.exports = __webpack_public_path__ + "static/media/bdo.8c63c40d.svg";